import { i18n } from '@lingui/core';
import { I18nProvider } from '@lingui/react';
import { ToastProvider } from 'app-ui/components';
import { Provider as JotaiProvider } from 'jotai';
import { ErrorBoundary } from 'react-error-boundary';
import { BrowserRouter } from 'react-router-dom';

import { AppErrorFallback } from '@/app/components/AppErrorFallback';
import { AppRouter } from '@/app/components/AppRouter';
import { AppToaster } from '@/app/components/AppToaster';
import { AppAuthProvider } from '@/auth/components/AppAuthProvider';
import { captureUnexpectedError } from '@/error-reporting/utils/captureUnexpectedError';
import { AppThemeProvider } from '@/ui/theme/components/AppThemeProvider';
import { jotaiStore } from '@/ui/utilities/state/jotai/jotaiStore';

// The router comes before sign-in, which navigates with it, and sign-in before
// Apollo, which sends its token. Apollo sits inside the toasts: its error link
// shows unexpected errors there.
export const App = () => (
  <JotaiProvider store={jotaiStore}>
    <I18nProvider i18n={i18n}>
      <AppThemeProvider>
        <ErrorBoundary
          FallbackComponent={AppErrorFallback}
          onError={captureUnexpectedError}
        >
          <ToastProvider>
            <BrowserRouter>
              <AppAuthProvider>
                <AppRouter />
              </AppAuthProvider>
            </BrowserRouter>
            <AppToaster />
          </ToastProvider>
        </ErrorBoundary>
      </AppThemeProvider>
    </I18nProvider>
  </JotaiProvider>
);
